import { Injectable } from '@angular/core';
import { httpResource } from '@angular/common/http';

/**
 * Service for general information.
 */
@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  /**
   * Returns the version of the tool service.
   */
  getBackendVersion() {
    return httpResource<{ version: string }>(() => 'internal/version');
  }

  /**
   * Returns the version of the frontend.
   */
  getFrontendVersion() {
    return httpResource.text(() => `${location.origin}/assets/version.txt`);
  }
}
